import { render, staticRenderFns } from "./roleFieldComponent.vue?vue&type=template&id=7b0faf32&scoped=true&"
import script from "./roleFieldComponent.vue?vue&type=script&lang=js&"
export * from "./roleFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0faf32",
  null
  
)

export default component.exports